import { createContext, FC, PropsWithChildren, useContext, useMemo } from 'react'

import { FEATURE_FLAG_TYPE, HomepageServerSideFeatureFlags } from '@src/server-side/feature-flags/feature-flag.types'

export interface HomepageFeatureFlags {
  featureFlagType: typeof FEATURE_FLAG_TYPE.HOME
  isPersonalized: boolean
  homepageDesignSystemBucket: string | null
}

export const HomepageFeatureContext = createContext<HomepageFeatureFlags | null>(null)

export const useHomepageFeature = (): HomepageFeatureFlags => {
  const context = useContext(HomepageFeatureContext)

  if (!context) {
    throw new Error('useHomepageFeature must be used within a HomeFeatureProvider')
  }

  return context
}

interface HomeFeatureProviderProps {
  serverSideFeatureFlags: HomepageServerSideFeatureFlags | null | undefined
}

export const HomepageFeatureProvider: FC<PropsWithChildren<HomeFeatureProviderProps>> = ({
  children,
  serverSideFeatureFlags,
}) => {
  const featureFlags = useMemo(
    (): HomepageFeatureFlags => ({
      featureFlagType: FEATURE_FLAG_TYPE.HOME,
      isPersonalized: serverSideFeatureFlags?.isPersonalized ?? false,
      homepageDesignSystemBucket: serverSideFeatureFlags?.homepageDesignSystemBucket ?? null,
    }),
    [serverSideFeatureFlags],
  )

  return <HomepageFeatureContext.Provider value={featureFlags}>{children}</HomepageFeatureContext.Provider>
}
